import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SabisNgxDialogComponent } from 'sabis-components2';
import { AppLoaderService } from './../../../@theme/shared/services/app-loader/app-loader.service';
import { AppLocalizationService } from '../../../core/app-localization/app-localization.service';
import { AppNotificationsService } from '../../../core/notifications/app-notifications.service';
import { HiringRequestApprovalsService } from '../hiring-request-approvals.service';
import { ApprovalStepDTO } from '../../models';
import { MatStepperModule } from '@angular/material/stepper';

@Component({
  selector: 'sca-approvals-list',
  templateUrl: './approvals-list.component.html',
  styleUrls: ['./approvals-list.component.scss'],
  imports: [
    SabisNgxDialogComponent,
    MatStepperModule
  ]
})
export class ApprovalsListComponent implements OnInit, OnDestroy {
  private _getApprovalHistorySubscription: Subscription = new Subscription();

  public approvalSteps: ApprovalStepViewModel[] = [];
  public istakingDecision: boolean = false;
  public isDisabled: boolean = true;
  public canTakeDecision: boolean = false;
  public canReject: boolean = false;
  private _hiringRequestId: number;// = this._navigation.getHiringRequestIdForEditor(this._route)!;

  constructor(private _approvals: HiringRequestApprovalsService,
    private _appLoader: AppLoaderService,
    public dialogRef: MatDialogRef<ApprovalsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _appNotification: AppNotificationsService,
    private _localization: AppLocalizationService) {
    this._hiringRequestId = data.hiringRequestId;
  }

  ngOnInit(): void {
    this._appLoader.showLoading();

    this._getApprovalHistorySubscription = this._approvals.getApprovalHistory(this._hiringRequestId).subscribe({
      next: (steps: ApprovalStepDTO[]) => {
        steps.forEach(step => {
          let summary = '';
          let decisionDate: string = step.decisionDate != null ? this._localization.formatDate(step.decisionDate) : '';
          this.canTakeDecision = step.canTakeDecision
          if (step.isApproved) {
            summary = `${step.ownerFullName} (${step.ownerUsername}) has approved this hiring request on ${decisionDate}`;
          }
          else if (step.isRejected) {
            summary = `${step.ownerFullName} (${step.ownerUsername}) has rejected this hiring request on ${decisionDate}`;
          }
          else {
            summary = `${step.ownerFullName} (${step.ownerUsername}) has not made a decision yet.`;
          }

          this.approvalSteps.push({
            summary: summary,
            canTakeDecision: step.canTakeDecision,
            approvalStep: step,
          });
        });

        this._appLoader.hideLoading();
      },
      error: () => {
        this._appNotification.unexpectedErrorOccurred();
        this._appLoader.hideLoading();
      },
      complete: () => {
        this._appLoader.hideLoading();
      }
    });
  }

  ngOnDestroy(): void {
    this._getApprovalHistorySubscription.unsubscribe();
  }
}

export interface ApprovalStepViewModel {
  summary: string,
  canTakeDecision: boolean,
  approvalStep: ApprovalStepDTO,
}
